export default __webpack_public_path__ + "static/media/producto-03.7579d68b.jpg";